import baseApi from "@/api/baseApi";
export default {
  addOrUpdate(form, context) {
    return baseApi.post(`/api-piglet/api/quantity-scale/${context}/v1`, form);
  },
  fetchAll(context) {
    return baseApi.get(`/api-piglet/api/quantity-scale/${context}/v1`);
  },
  remove(id, context) {
    return baseApi.delete(`/api-piglet/api/quantity-scale/${context}/${id}/v1`);
  }
}
